import React from "react";
import { LogOut } from "lucide-react";
import { supabase } from "@/integrations/supabase/client";
import { useNavigate } from "react-router-dom";
import { useToast } from "@/components/ui/use-toast";

interface FooterProps {
  isCollapsed: boolean;
}

export const SidebarFooter: React.FC<FooterProps> = ({ isCollapsed }) => {
  const navigate = useNavigate();
  const { toast } = useToast();

  const handleLogout = async () => {
    try {
      await supabase.auth.signOut();
      toast({
        title: "Logout realizado",
        description: "Você foi desconectado com sucesso!",
      });
      navigate('/');
    } catch (error) {
      console.error("Error during logout:", error);
      toast({
        title: "Erro ao sair",
        description: "Houve um problema ao fazer logout. Tente novamente.",
        variant: "destructive",
      });
    }
  };

  return (
    <div className="px-3 py-4 mt-auto">
      <div className={`h-px w-full bg-gradient-to-r from-transparent via-[#2A3749] to-transparent mb-3 ${isCollapsed ? 'opacity-30' : ''}`}></div>
      
      {/* Botão de Sair */}
      <div className="mb-3">
        <button
          onClick={handleLogout}
          className={`w-full flex items-center gap-2 px-3 py-2 rounded-lg text-gray-400 hover:text-red-400 hover:bg-red-900/20 transition-all ${
            isCollapsed ? 'justify-center' : 'justify-start'
          }`}
          title="Sair"
        >
          <LogOut className="h-4 w-4" />
          {!isCollapsed && <span className="text-sm font-medium">Sair</span>}
        </button>
      </div>
      
      <div className="flex justify-center">
        <div className={`text-xs text-gray-500 ${isCollapsed ? 'rotate-90 origin-center mt-10' : ''}`}>
          {!isCollapsed ? 'GameMentors © 2025' : 'GM 2025'}
        </div>
      </div>
    </div>
  );
};
